<template>
	<label class="sort-label">
		<input class="sort-label__input" type="checkbox" v-model="valueModel" />
		<span class="sort-label__title" :style="style">{{ title }}</span>
		<i
			class="sort-label__icon fa fa-long-arrow-up"
			v-if="propsValue !== null"
			aria-hidden="true"
			:style="[style, iconStyle]"
		></i>
	</label>
</template>

<script>
	export default {
		name: 'SortLabel',
		props: {
			id: {
				required: true,
				type: [Number, String],
			},
			title: {
				required: true,
				type: String,
			},
			propsValue: {
				required: true,
				validator: prop => typeof prop === 'boolean' || prop === null,
				default: null,
			},
			size: {
				default: 0.875,
				type: Number,
			},
			down: {
				type: [Number, String],
			},
			up: {
				type: [Number, String],
			},
		},
		computed: {
			valueModel: {
				get() {
					return this.propsValue;
				},
				set(newValue) {
					this.$emit('change', [
						{
							newValue,
							id: this.id,
						},
					]);
				},
			},
			style() {
				const style = {};
				style.fontSize = `${this.size}rem`;
				return style;
			},
			iconStyle() {
				const style = {};
				if (this.propsValue === true) {
					style.transform = 'rotate(180deg)';
				}
				return style;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.sort-label {
		cursor: pointer;
		display: inline-block;
		padding: 2px;
		font-size: 0;

		.sort-label__input {
			display: none;
		}

		.sort-label__title,
		.sort-label__icon {
			cursor: pointer;
			display: inline-block;
			margin: 0 2px;
			vertical-align: middle;
			line-height: 16px;
		}

		.sort-label__title {
			color: $font-blue;
		}
	}
</style>
